import { CalendarMode } from 'antd/lib/calendar/generateCalendar'
import dayjs, { Dayjs } from 'dayjs'
import React, { createContext, useContext, useState } from 'react'
import { OpportunityNexContactFilter } from '../../../entities'
import useOpportunityNexContact from '../../../services/queries/opportunity/useOpportunityNexContact'
import { dateFormat } from '../../../utils/format/dateFormat'

export interface CalendarContextData {
  data: any
  loading: boolean
  selected: any[] | null
  setSelected(id: any): void
  handlePanelChangle(moment: Dayjs, mode: string): void
  mode: CalendarMode
  calendarValue: any
}

export const CalendarContext = createContext<CalendarContextData>(
  {} as CalendarContextData
)

export const CalendarProvider: React.FC = ({ children }: any) => {
  //TODO: set Data type
  const [mode, setMode] = useState<CalendarMode>('month')
  const [calendarValue, setCalendarValue] = useState<any>(null)
  const [filters, setFilters] = useState<OpportunityNexContactFilter>({
    startDate: dayjs().startOf('month'),
    endDate: dayjs().endOf('month')
  })

  const [selected, _setSelected] = useState<any[] | null>(null)
  const { data, isLoading } = useOpportunityNexContact({
    page: 1,
    limit: 99999,
    filters
  })

  const handlePanelChangle = async (moment: Dayjs, mode: CalendarMode) => {
    console.log(moment)
    setCalendarValue(moment)
    setMode(mode)
    setFilters({
      startDate: dayjs(moment).startOf(mode),
      endDate: dayjs(moment).endOf(mode)
    })
  }

  const setSelected = (date: any) => {
    let selectedData = null
    if (mode === 'month')
      if (date) {
        const filteredData = data?.data?.filter((d: any) => {
          return dateFormat(d?.date) === dateFormat(date)
        })
        selectedData =
          filteredData && filteredData.length > 0 ? filteredData : null
      }
    if (mode === 'year')
      if (date) {
        const filteredData = data?.data?.filter((d: any) => {
          console.log(dateFormat(d.date), dateFormat(date))
          return (
            dayjs(d.date).format('MM/YYYY') === dayjs(date).format('MM/YYYY')
          )
        })
        selectedData =
          filteredData && filteredData.length > 0 ? filteredData : null
      }

    _setSelected(selectedData)
  }

  return (
    <CalendarContext.Provider
      value={{
        data: data?.data || [],
        loading: isLoading,
        mode,
        selected,
        setSelected,
        handlePanelChangle,
        calendarValue
      }}
    >
      {children}
    </CalendarContext.Provider>
  )
}

export const useCalendarContext = () => useContext(CalendarContext)
